import { render, staticRenderFns } from "./AppUpdateBanner.vue?vue&type=template&id=742c8a7a&scoped=true&"
import script from "./AppUpdateBanner.vue?vue&type=script&lang=js&"
export * from "./AppUpdateBanner.vue?vue&type=script&lang=js&"
import style0 from "./AppUpdateBanner.vue?vue&type=style&index=0&id=742c8a7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c8a7a",
  null
  
)

export default component.exports